import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayersBehind: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayersBehind"><Path d="M2.5 19.5V6.5H21.5V19.5H2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 3.5H19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconLayersBehind;
